class FeedbackBar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.message_container = this.querySelector(".feedback-bar--message")),
      (this.message_json = JSON.parse(this.querySelector("script").innerHTML)),
      this.load(),
      this.quantityListener();
  }
  load() {
    var e = window.location.hash.substring(1).replace("feedback-bar--", "");
    this.message_json[e] &&
      ((this.message_container.innerText = this.message_json[e]),
      setTimeout(() => this.setAttribute("data-open", !0), 200),
      setTimeout(() => {
        this.setAttribute("data-open", !0);
        this.message_container.style.display = "inline-block";
      }, 200),
      setTimeout(() => {
        this.setAttribute("data-open", !1);
        this.message_container.style.display = "none";
      }, 5e3),
      history.pushState(
        "",
        document.title,
        "" + window.location.pathname + window.location.search
      ));
  }
  quantityListener() {
    window.on("theme:feedbackBar:quantity", ({ detail: e }) => {
      1 < e && this.addNewQuantityMessage(e), this.load();
    });
  }
  addNewQuantityMessage(e) {
    var t = this.message_json["product--n-items"].replace("[num_items]", e);
    this.message_json[`product--${e}-items`] = t;
  }
}
customElements.define("feedback-bar-root", FeedbackBar);
